import { api } from "./api";

// Coupons admin + engine API surface — mirrors docs/coupons-system.md §15.

export const couponListApi = (params = {}) =>
  api.get(`/coupons`, { params });

export const couponGetApi = (params) =>
  api.get(`/coupons/${encodeURIComponent(params.id)}`);

export const couponCreateApi = (params) =>
  api.post(`/coupons`, JSON.stringify(params));

export const couponUpdateApi = (params) =>
  api.put(`/coupons/${encodeURIComponent(params.id)}`, JSON.stringify(params.body || params));

export const couponPauseApi = (params) =>
  api.post(`/coupons/${encodeURIComponent(params.id)}/pause`, JSON.stringify(params.body || {}));

export const couponResumeApi = (params) =>
  api.post(`/coupons/${encodeURIComponent(params.id)}/resume`, JSON.stringify(params.body || {}));

export const couponArchiveApi = (params) =>
  api.post(`/coupons/${encodeURIComponent(params.id)}/archive`, JSON.stringify(params.body || {}));

export const couponSeriesGetApi = (params) =>
  api.get(`/coupons/series/${encodeURIComponent(params.id)}`);

export const couponSeriesCancelApi = (params) =>
  api.post(
    `/coupons/series/${encodeURIComponent(params.id)}/cancel`,
    JSON.stringify(params.body || {})
  );

export const couponCodeLookupApi = (params) =>
  api.get(`/coupons/code/${encodeURIComponent(params.code)}`, {
    params: { bill_total: params.bill_total },
  });

export const couponApplyApi = (params) =>
  api.post(`/coupons/apply`, JSON.stringify(params));

export const couponReverseApi = (params) =>
  api.post(`/coupons/reverse`, JSON.stringify(params));

export const couponUsageSyncApi = (params) =>
  api.post(`/coupons/sync/usage-batch`, JSON.stringify(params));
